import { NetworkIdSchema } from "#network/network.js";
import z$1 from "zod";
//#region src/mempool/mempool.ts
let MempoolTxnStatus = /* @__PURE__ */ function(MempoolTxnStatus) {
	MempoolTxnStatus["TRANSACTION_STATUS_UNSPECIFIED"] = "unspecified";
	MempoolTxnStatus["MINED"] = "mined";
	MempoolTxnStatus["PENDING"] = "pending";
	MempoolTxnStatus["DROPPED"] = "dropped";
	MempoolTxnStatus["REORGED"] = "reorged";
	MempoolTxnStatus["FINALIZED"] = "finalized";
	MempoolTxnStatus["EXECUTED"] = "executed";
	MempoolTxnStatus["SEALED"] = "sealed";
	MempoolTxnStatus["EXPIRED"] = "expired";
	MempoolTxnStatus["DROPPED_AND_REPLACED"] = "dropped_and_replaced";
	return MempoolTxnStatus;
}({});
const MempoolTxnSchema = z$1.object({
	appId: z$1.string().optional(),
	appName: z$1.string().optional(),
	networkId: NetworkIdSchema.optional(),
	txnData: z$1.string(),
	txnHash: z$1.string(),
	fromAddress: z$1.string().optional(),
	toAddress: z$1.string().optional(),
	nonce: z$1.number().optional(),
	gas: z$1.string().optional(),
	blockNumber: z$1.number().optional(),
	txnStatus: z$1.nativeEnum(MempoolTxnStatus).optional(),
	requestedAt: z$1.string().datetime().optional(),
	statusChangedAt: z$1.string().datetime().optional(),
	maxFeePerGas: z$1.string().optional(),
	maxPriorityFeePerGas: z$1.string().optional(),
	type: z$1.string().optional(),
	value: z$1.string().optional()
});
//#endregion
export { MempoolTxnSchema, MempoolTxnStatus };

//# sourceMappingURL=mempool.js.map